<span *ngIf="isLoading$ | async">
  <app-preloader [isFullPreloader]="true" />
</span>

<section class="page-title-area">
  <div class="container">
    <div class="page-title-content" *ngFor="let pageTitle of pageTitleArea">
      <h2>{{ pageTitle?.title }}</h2>
      <ul>
        <li><a routerLink="/">Home</a></li>
        <li>{{ pageTitle?.title }}</li>
        <li>{{ pageTitle?.subTitle }}</li>
      </ul>
    </div>
  </div>

  <div class="shape-img1">
    <img src="assets/img/shape/shape1.svg" alt="image" />
  </div>
  <div class="shape-img2">
    <img src="assets/img/shape/shape2.png" alt="image" />
  </div>
  <div class="shape-img3">
    <img src="assets/img/shape/shape3.png" alt="image" />
  </div>
</section>

<section class="case-studies-details-area pb-100">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div
          *ngFor="let image of contentImages"
          class="case-studies-details-image">
          <img [src]="image" alt="image" />
        </div>
        <div *ngIf="video" class="case-studies-details-video">
          <video controls>
            <source [src]="video" />
          </video>
        </div>

        <div class="case-studies-details-desc">
          <span style="text-align: center" class="sub-title">
            {{ story?.title }}
          </span>
          <h3>Business Challenge</h3>
          <p [innerHTML]="story?.business_challenges"></p>
          <h3>Solution</h3>
          <p [innerHTML]="story?.solutions"></p>
          <h3>Benefits & Results</h3>
          <p [innerHTML]="story?.benefits_results"></p>
          <div class="display-grid">
            <div>
              <h6>
                Created by
                <i
                  class="fa fa-info-circle"
                  matTooltip="Name of the person who create the success story"></i>
              </h6>
              <span class="sub-title">{{ story?.post_by?.displayName }}</span>
              <h6>
                Created date
                <i class="fa fa-info-circle" matTooltip="Format MM-DD-YYYY"></i>
              </h6>
              <span class="sub-title">{{ story?.post_date }}</span>
            </div>
            <div class="display-gridright">
              <h6 *ngIf="story?.last_modified_by?.displayName !== null">
                Modified By
                <i
                  class="fa fa-info-circle"
                  matTooltip="Name of the person who modify the success story"></i>
              </h6>
              <span
                class="sub-title"
                *ngIf="story?.last_modified_by?.displayName !== null">
                {{ story?.last_modified_by?.displayName }}
              </span>
              <h6 *ngIf="story?.last_modified_by !== null">
                Modified date
                <i class="fa fa-info-circle" matTooltip="Format MM-DD-YYYY"></i>
              </h6>
              <span
                class="sub-title"
                *ngIf="story?.last_modified_by?.displayName !== null">
                {{ story?.last_modified_date }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="this.showbutton">
      <button
        mat-fab
        extended
        color="primary"
        class="button"
        [routerLink]="['/edit-success-story', id]">
        <mat-icon>edit</mat-icon>
        Edit
      </button>
      <button
        type="button"
        mat-fab
        extended
        color="warn"
        class="btn btn-danger float-start"
        (click)="deleteData(id)">
        <mat-icon>delete_forever</mat-icon>
        Delete
      </button>
    </div>
  </div>
</section>
